import {
  CATCH_BOARD_OWNER_FILTER,
  CATCH_BOARD_READINESS_FILTER,
  CATCH_BOARD_READINESS_FILTER_META,
} from 'src/screens/catch-board/catchBoardConstants'

export function hasCatchBoardListFilters({
  search = '',
  hideClosed = false,
  readinessFilter = CATCH_BOARD_READINESS_FILTER.ALL,
} = {}) {
  return Boolean(
    String(search || '').trim() ||
      hideClosed ||
      (readinessFilter &&
        readinessFilter !== CATCH_BOARD_READINESS_FILTER.ALL),
  )
}

const READINESS_QUEUE_EMPTY_COPY = Object.freeze({
  [CATCH_BOARD_READINESS_FILTER.SALES_READY]: {
    title: 'No sales-ready deals',
    hint:
      'Nothing ripe for contact right now — try All readiness, or mark a deal Sales ready.',
    showAllDeals: true,
  },
  [CATCH_BOARD_READINESS_FILTER.CUSTOMER_SUCCESS]: {
    title: 'No CS blockers',
    hint:
      'Nothing waiting on customer success — try All readiness, or clear this queue.',
    showAllDeals: true,
  },
  [CATCH_BOARD_READINESS_FILTER.PRODUCT]: {
    title: 'No product blockers',
    hint:
      'Nothing waiting on product — try All readiness, or clear this queue.',
    showAllDeals: true,
  },
  [CATCH_BOARD_READINESS_FILTER.NOT_TRIAGED]: {
    title: 'No untriaged deals',
    hint:
      'Everything already has a readiness — try All readiness, or create a new deal.',
    showAllDeals: true,
  },
})

/**
 * Board-level empty copy — list filters vs a truly empty pipeline.
 * Readiness-only queues get specialized copy; search / hide-closed stay generic.
 * @param {{ search?: string, hideClosed?: boolean, ownerFilter?: string, readinessFilter?: string }} filters
 */
export function getCatchBoardEmptyCopy({
  search = '',
  hideClosed = false,
  ownerFilter = CATCH_BOARD_OWNER_FILTER.MINE,
  readinessFilter = CATCH_BOARD_READINESS_FILTER.ALL,
} = {}) {
  const hasSearch = Boolean(String(search || '').trim())
  const hasHideClosed = Boolean(hideClosed)
  const hasReadinessQueue =
    readinessFilter &&
    readinessFilter !== CATCH_BOARD_READINESS_FILTER.ALL

  if (hasReadinessQueue && !hasSearch && !hasHideClosed) {
    return (
      READINESS_QUEUE_EMPTY_COPY[readinessFilter] || {
        title: `No ${CATCH_BOARD_READINESS_FILTER_META[readinessFilter]?.label || 'filtered'} deals`,
        hint: 'Try All readiness, or switch to All deals.',
        showAllDeals: true,
      }
    )
  }

  if (hasSearch || hasHideClosed || hasReadinessQueue) {
    return {
      title: 'No deals match these filters',
      hint:
        'Try All readiness, All deals, clear search, or show closed deals.',
      showAllDeals: true,
    }
  }

  if (ownerFilter === CATCH_BOARD_OWNER_FILTER.MINE) {
    return {
      title: 'No deals assigned to you yet',
      hint:
        'Switch to All deals, or create one — or add a venue from Spartacus / Crow’s Nest.',
      showAllDeals: true,
    }
  }
  if (ownerFilter === CATCH_BOARD_OWNER_FILTER.UNASSIGNED) {
    return {
      title: 'No unassigned deals',
      hint: 'Switch to All deals, or create a deal without an owner.',
      showAllDeals: true,
    }
  }
  return {
    title: 'No deals yet',
    hint: 'Create a deal, or add one from Spartacus or Crow’s Nest.',
    showAllDeals: false,
  }
}
